<fa-icon [icon]="icon" [fixedWidth]="true" class="bookshelf-card-action-item-icon"></fa-icon>
<span class="bookshelf-card-action-item-label ml-2 text-capitalize"
      translate
      data-automation-id="bookshelf-card-action-item-text">{{messageKey}}</span>
